import { useTranslate } from '@tolgee/react';
import { message } from 'antd';
import { confirmReturn, disputeReturn, returnReviewResolve } from 'services/api/return';
import { getApiErrorCodeMsg } from 'services/api/utils/errorCode';
import MercadoOffer from 'components/Refund/MercadoOffer';
import StatusButton from 'components/StatusButton';
import { formatNumber } from 'utils/numberFormat';
import { ReturnReviewReject } from './ReturnReviewReject';
import { ReturnActionMercadoProps } from './types';

const ReturnRefund = ({
  externalStoreId,
  externalTradeId,
  returnSn,
  platform,
  refreshList,
}: ReturnActionMercadoProps) => {
  const { t } = useTranslate();

  return (
    <StatusButton
      size="small"
      popConfirmProps={{
        title: t('ViewRefund.确认同意买家的退货退款申请吗？'),
      }}
      onClick={() =>
        confirmReturn({
          externalStoreId,
          externalTradeId,
          returnSn,
          externalType: platform,
          operate: 'CONFIRM_RETURN_REFUND',
        })
          .then(() => {
            refreshList?.();
            message.success(t('phrase.保存成功'));
          })
          .catch((err) => {
            message.error(getApiErrorCodeMsg(err.response));
          })
      }
    >
      {t('btn_agree_refunds')}
    </StatusButton>
  );
};

const OnlyRefund = ({
  externalStoreId,
  externalTradeId,
  returnSn,
  platform,
  unit,
  refundAmount,
  refreshList,
}: ReturnActionMercadoProps) => {
  const { t } = useTranslate();

  return (
    <StatusButton
      size="small"
      popConfirmProps={{
        title: t('trade.全额退款提示', {
          money: `${unit}${formatNumber(refundAmount, '0,0.00')}`,
        }),
      }}
      onClick={() =>
        confirmReturn({
          externalStoreId,
          externalTradeId,
          returnSn,
          externalType: platform,
          operate: 'CONFIRM_ONLY_REFUND',
        })
          .then(() => {
            refreshList?.();
            message.success(t('phrase.保存成功'));
          })
          .catch((err) => {
            message.error(getApiErrorCodeMsg(err.response));
          })
      }
    >
      {t('btn_agree_only_refund')}
    </StatusButton>
  );
};

const Dispute = ({ returnSn, refreshList }: ReturnActionMercadoProps) => {
  const { t } = useTranslate();

  return (
    <StatusButton
      size="small"
      onClick={() => {
        return disputeReturn({
          platform: 'MERCADO',
          returnSn,
          operate: 'DISPUTE',
        })
          .then(() => {
            refreshList?.();
            message.success(t('phrase.保存成功'));
          })
          .catch(() => {
            message.error(t('phrase.保存失败，请稍后再试'));
          });
      }}
    >
      {t('申请平台介入')}
    </StatusButton>
  );
};

const ReturnReviewResolve = (props: ReturnActionMercadoProps) => {
  const { returnSn, refreshList } = props;
  const { t } = useTranslate();

  return (
    <StatusButton
      size="small"
      popConfirmProps={{
        title: t('确认通过验收退货吗？'),
      }}
      onClick={() =>
        returnReviewResolve('MERCADO', returnSn)
          .then(() => {
            refreshList?.();
            message.success(t('phrase.保存成功'));
          })
          .catch(() => {
            message.error(t('phrase.保存失败，请稍后再试'));
          })
      }
    >
      {t('验收退货通过')}
    </StatusButton>
  );
};

export const getReturnActionMercado = (props: ReturnActionMercadoProps) => {
  const { returnSn, refundAmount, unit, operate = [], refreshList } = props;

  return [
    operate.includes('CONFIRM_RETURN_REFUND') && <ReturnRefund {...props} />,
    operate.includes('OFFER') && (
      <MercadoOffer
        returnExternalId={returnSn}
        refundAmount={refundAmount}
        unit={unit}
        onSuccess={refreshList}
      />
    ),
    operate.includes('RETURN_REVIEW_OK') && <ReturnReviewResolve {...props} />,
    operate.includes('RETURN_REVIEW_FAIL') && <ReturnReviewReject {...props} />,
    operate.includes('CONFIRM_ONLY_REFUND') && <OnlyRefund {...props} />,
    operate.includes('DISPUTE') && <Dispute {...props} />,
  ];
};

export const ReturnActionMercado = (props: ReturnActionMercadoProps) => (
  <>{getReturnActionMercado(props)}</>
);
